import { nextTick, ref } from 'vue';

/**
 * Responsible for managing state in the MobileNavigation component.
 */
const useMobileMenu = () => {
  const mobileMenuOpen = ref(false);

  /**
   * Closes the mobile menu and ensures scrolling is restored.
   */
  const closeMobileMenu = () => {
    mobileMenuOpen.value = false;
    document.querySelector('body').classList.remove('stop-scrolling');
  };

  /**
   * Used by the FocusTrap component and is responsible
   * for setting the focus when the mobile menu is opened.
   *
   * @returns {Element}
   */
  const initialMobileMenuFocus = () => document.querySelector('#flyoutPanel');

  /**
   * Opens the mobile menu and ensures scrolling is disabled.
   */
  const openMobileMenu = () => {
    mobileMenuOpen.value = true;
    document.querySelector('body').classList.add('stop-scrolling');

    // Focuses the navigation when the mobile menu is opened
    nextTick(() => {
      initialMobileMenuFocus().focus();
    });
  };

  return {
    mobileMenuOpen,
    closeMobileMenu,
    openMobileMenu,
    initialMobileMenuFocus,
  };
};

export default useMobileMenu;
